import React, { useState, useEffect } from 'react';
import { useMutation } from '@apollo/react-hooks';
import { gql } from 'apollo-boost';

/** @import {ResendActivationOtpProps} from './ResendActivationOtpTypes' */

import chevRight from '../../assets/images/chev-right-royal.svg';

function ResendActivationOtp(/** @type {ResendActivationOtpProps} */ props) {
  const RESEND_ACTIVATION_OTP = gql`
      mutation ResendActivationOtp($request : ResendActivationOtpRequestType!){
      resendActivationOtp(request:$request) {
        success
        verificationToken
      }
    }  
  `;

  const [hideResendLink, setHideResendLink] = useState(false);
  const [resendCount, setResendCount] = useState(0);
  const [tick, setTick] = useState(30);
  const [startTick, setStartTick] = useState(false);
  const [maxResendsSent, setMaxResendsSent] = useState(false);

  const [resendActivationOtp] = useMutation(RESEND_ACTIVATION_OTP);

  useEffect(() => {
    // exit early when we reach 0
    if (!tick || !startTick || resendCount === 4) {
      setStartTick(false);
      setTick(30);
      setHideResendLink(false);

      if (props.isResendingCallback) {
        props.isResendingCallback(false);
      }

      return;
    }

    if (tick === 1) {
      resendClientActivationOtp();
      if (resendCount === 3) {
        setMaxResendsSent(true);
      }
    }

    // save intervalId to clear the interval when the
    // component re-renders
    const intervalId = setInterval(() => {
      setTick(tick - 1);
    }, 1000);

    // clear interval on re-render to avoid memory leaks
    return () => clearInterval(intervalId);
    // add timeLeft as a dependency to re-rerun the effect
    // when we update it
  }, [tick, startTick]);

  const resendClicked = (/** @type {React.MouseEvent<HTMLAnchorElement, MouseEvent>} */ _e) => {
    setResendCount(resendCount + 1);
    setStartTick(true);
    setHideResendLink(true);

    if (props.isResendingCallback) {
      props.isResendingCallback(true);
    }
  };

  const resendClientActivationOtp = async () => {
    await resendActivationOtp({
      variables: {
        request: {
          mobileNumber: props.mobileNumber
        }
      }
    });
  }

  const renderMaxRetries = () => {
    return <span className={props.counterClassName}><b>One-time password sent. You've now sent the maximum number of one-time passwords.</b></span>;
  };

  const render = () => {
    if (maxResendsSent) {
      return renderMaxRetries();
    }
    
    if (hideResendLink) {
      return <span className={props.counterClassName}><b>Sending new one-time password in {tick} second{tick !== 1 ? 's' : '' }.</b></span>
    }

    return <a href="#" className={props.linkClassName} onClick={resendClicked}>Resend one-time password <img src={chevRight} /></a>;
  };

  return render();
};

export default ResendActivationOtp;